import React, { useMemo } from 'react'
import { Handle } from 'react-flow-renderer'

import { FiTrash2 } from 'react-icons/fi'

import styles from './style.module.css'

const FinishDemonstration = ({
    onDragStart = () => { }
}) => {
    return (
        <div className={styles.container_demonstration} onDragStart={onDragStart} draggable>
            <p>Конец</p>
        </div>
    )
}

const dataInit = {
    onRemove: () => { }
}

const Finish = ({
    id = '',
    data = {}
}) => {
    const _data = useMemo(() => ({ ...dataInit, ...data }), [data])

    return (
        <div className={styles.container}>
            <Handle type='target' position='left' id='in' className={styles.point_in} />
            <FiTrash2
                className={styles.icon}
                onClick={() => _data.onRemove(id)}
            />
            <p>Конец</p>
        </div>
    )
}

export { Finish, FinishDemonstration }